<app-navbar></app-navbar>
<router-outlet></router-outlet>

<app-pop-up *ngIf="popUpController.showPopUp"></app-pop-up>
<app-alert *ngIf="alertController.showAlert"></app-alert>
<app-alert-loading *ngIf="alertController.loading"></app-alert-loading>
<app-toast *ngIf="toastController.showToast"></app-toast>

<app-splash></app-splash>
